import { App } from '~/app';
import { isMobile } from '@root/src/framework/scripts/helpers/browser/media-query';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Image Area Focus Component');

    const listeners: Array<[Element | Window, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount

        .then(() => {
            mountImageAreaFocus(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Image Area Focus Component', error);
        });

    return function destroyImageAreaFocus() {
        unMountImageAreaFocus(listeners);

        app.logger.debug('[DXA] Image Area Focus Component destroyed');
    };
};

function mountImageAreaFocus(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;

    const imageAreaFocus = rootNode.querySelectorAll<HTMLElement>('.image-area-focus')

    imageAreaFocus.forEach((area)=> {
        const hoverItem = area.querySelectorAll<HTMLElement>('.hover-item')
        const hoverTarget = area.querySelectorAll<HTMLElement>('.hover-target')
        const buildingImages = area.querySelectorAll<HTMLElement>('.building-images')

        const preventFirstMobileLinkClick = () => {
            const buildingLinks = area.querySelectorAll<HTMLElement>('.building-link')
            buildingLinks.forEach((link)=>{
                if (isMobile(1025)){
                    let firstClick = true
                    link?.addEventListener('click', (e)=>{
                        if (firstClick) {
                            e.preventDefault()
                            firstClick = false;
                        } else{
                            firstClick = true;
                        }
                    })
                }
            })
        }

        preventFirstMobileLinkClick()
		
        window.addEventListener('resize', preventFirstMobileLinkClick);
        listeners.push([window, 'resize', preventFirstMobileLinkClick]);

        let activeAutoPlay = 0;
        let intervalCount = 0;
        const autoPlayInterval = setInterval(() => {
            buildingImages.forEach((building)=>{
                //Show hovered building
                if(building.dataset.group === buildingImages[activeAutoPlay].dataset.group ){
                    building.classList.remove('opacity-0','lg:opacity-0')
                } else {
                    building.classList.remove('opacity-100')
                    building.classList.remove('lg:opacity-100')
                    building.classList.add('opacity-0')
                }
            })
            hoverTarget.forEach((target)=> {
                //Hide building 1 mobile text and show hovered text
                if(target.dataset.group === hoverTarget[activeAutoPlay].dataset.group) {
					 target.classList.remove('hidden','lg:hidden')
                }else{
                    target.classList.add('hidden')
                }
            })
            activeAutoPlay = intervalCount%buildingImages.length;
            intervalCount++;
        }, 5000);

        hoverItem.forEach((item)=> {
            item.addEventListener('mouseover', ()=>{
                clearInterval(autoPlayInterval);
                buildingImages.forEach((building)=>{
                    //Show hovered building
                    if(building.dataset.group === 'mpark-group-1' && building.dataset.group === item.dataset.group){
                        building.classList.add('opacity-100','lg:opacity-100')
                        building.classList.remove('opacity-0')
                    } else if(building.dataset.group === item.dataset.group ){
                        building.classList.remove('opacity-0','lg:opacity-0')
                    } else {
                        building.classList.remove('opacity-100')
                        building.classList.remove('lg:opacity-100')
                        building.classList.add('opacity-0')
                    }
                })

                hoverTarget.forEach((target)=> {
                    //Hide building 1 mobile text and show hovered text
                    if(item.dataset.group !== 'mpark-group-1' && target.dataset.group === 'mpark-group-1' ){
                        target.classList.add('hidden','lg:hidden')
                    }else if(target.dataset.group === item.dataset.group) {
							 target.classList.remove('hidden','lg:hidden')
                    }else{
                        target.classList.add('hidden')
                    }
                })
            })
        })

    })
}

function unMountImageAreaFocus(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}